import TemporaryHire from "../../images/staffing//TemporaryHires.png"
import DirectHire from "../../images/staffing/DirectHire.png"
import ContractHire from "../../images/staffing/Contract-to-hire.png"



export const data = [
    {
        id: 1,
        title: "Temporary Hires",
        question: "Need to hire on a project basis?",
        text: "We staff that.",
        right: true,
        img: TemporaryHire

    },
    {
        id: 2,
        title: "Direct Hire",
        question: "Need to jump start your team?",
        text: "We staff that.",
        right: false,
        img: DirectHire
    },
    {
        id: 3,
        title: "Contract-to-Hire",
        question: "Need results before making a commitment? See the pattern?",
        text: "We staff that too.",
        right: true,
        img: ContractHire
    }
]